module.exports = __webpack_public_path__ + "img/23.62d14f9f.png";